import React from "react";
import { useStateContext } from "../contexts/ContextProvider";
import Button from "./Button";
import AlertBox from "./AlertBox";
import RoomsCard from "./RoomsCard";
import EditProperty from "./EditProperty";
import AddRoom from "./AddRoom";
import ManageRoom from "./ManageRoom";

import { BiHome, BiBuildingHouse } from "react-icons/bi";
import { PiBuildingApartment } from "react-icons/pi";
import { BsHouses, BsBuildings } from "react-icons/bs";
import { IoBedOutline } from "react-icons/io5";
import { FaCirclePlus } from "react-icons/fa6";
import { TbStairsDown } from "react-icons/tb";
import { GiTreehouse } from "react-icons/gi";
import SplitBillModal from "./ManageBillsModal";
import AddExpenseModal from "./AddExpenseModal";
import ManageChoresModal from "./ManageChoresModal";
import ManageBillsModal from "./ManageBillsModal";

import { apiDeleteProperty, apiUpdateProperty } from "../services/apiService";
import NavigateBack from "./NavigateBack";
import ManageExpensesModal from "./ManageExpensesModal";

const ManageProperty = (props) => {
  const { currentPropertyId, usersProperties, setUsersProperties } = props;
  const {
    modal,
    alert,
    handleAlert,
    handleModal,
    rooms,
    setRooms,
    leases,
    currentRoomId,
    setCurrentRoomId,
    address,
    setAddress,
    chores,
    setChores,
    resetAddress,
    hasErrors,
  } = useStateContext();

  let currentProperty = usersProperties.find((x) => x.id === currentPropertyId);
  let currentPropertyRooms = rooms.filter(
    (x) => x.propertyId === currentPropertyId
  );
  let currentPropertyLeases = leases.filter(
    (x) => x.propertyId === currentPropertyId
  );

  const getIcon = (homeType) => {
    if (homeType === "house") return <BiHome />;
    if (homeType === "apartment") return <PiBuildingApartment />;
    if (homeType === "condo") return <BiBuildingHouse />;
    if (homeType === "townhouse") return <BsHouses />;
    if (homeType === "loft") return <BsBuildings />;
    if (homeType === "basement") return <TbStairsDown />;
    if (homeType === "tiny house") return <BiHome />;
    if (homeType === "other") return <GiTreehouse />;
  };

  const handleDeleteProperty = async (id) => {
    // delete property route (rooms and chores should cascade)
    const response = await apiDeleteProperty(id);
    if (response.hasError) {
      //TODO: add error message
      return;
    } else {
      handleModal("manageProperty");
      setUsersProperties(
        usersProperties.toSpliced(
          usersProperties.findIndex((x) => x.id === id),
          1
        )
      );

      //delete all rooms for this property
      let propertyRooms = rooms.filter((x) => x.propertyId === id);
      let newRoomsArray = rooms.filter((x) => !propertyRooms.includes(x));
      setRooms(newRoomsArray);

      // delete all chores for this property
      let propertyChores = chores.filter((x) => x.propertyId === id);
      let newChoresArray = chores.filter((x) => !propertyChores.includes(x));
      setChores(newChoresArray);
    }
  };

  const updateProperty = async (id) => {
    if (hasErrors()) {
      return;
    } else {
      const response = await apiUpdateProperty(id, address);
      if (response.hasError) {
        //TODO: add error messag
        return;
      } else {
        setUsersProperties(
          usersProperties.toSpliced(
            usersProperties.findIndex((x) => x.id === id),
            1,
            response.data.property
          )
        );
        setRooms(response.data.rooms);
        resetAddress();
        handleModal("editProperty");
      }
    }
  };

  return (
    <div
      className="w-screen fixed left-0 right-0 top-0 bottom-0 bg-white 
      overflow-y-auto overscroll-none mt-20 z-10"
    >
      <NavigateBack
        zIndex="z-10"
        returnText="Back to dashboard"
        modalNavigation={() => {
          handleModal("manageProperty");
        }}
      />
      {alert.deleteProperty && (
        <AlertBox
          alertType="deleteProperty"
          handleAlert={handleAlert}
          alertFunc={() => {
            handleDeleteProperty(currentPropertyId);
          }}
        />
      )}
      {modal.editProperty && (
        <EditProperty
          updateProperty={() => {
            updateProperty(currentPropertyId);
          }}
          // currentProperty={currentProperty}
          cancelEditProperty={() => {
            handleModal("editProperty");
            resetAddress();
          }}
        />
      )}
      {modal.addRoom && (
        <AddRoom
          cancelAddRoom={() => {
            handleModal("addRoom");
          }}
          handleModal={handleModal}
          currentProperty={currentProperty}
        />
      )}
      {modal.manageRoom && (
        <ManageRoom
          currentProperty={currentProperty}
          currentRoomId={currentRoomId}
        />
      )}
      {modal.manageBills && (
        <ManageBillsModal currentProperty={currentProperty} />
      )}
      {modal.manageChores && (
        <ManageChoresModal currentProperty={currentProperty} />
      )}
      {modal.manageExpenses && (
        <ManageExpensesModal currentProperty={currentProperty} />
      )}
      <div className="grid justify-items-center mt-10">
        <div className="relative flex w-full bg-gray-300 pt-3 px-5">
          <div className="grid justify-items-center">
            <div className=" bg-gray-200 py-3 px-5 text-6xl">
              {getIcon(currentProperty.homeType)}
            </div>
            <div className="flex items-center text-lg pt-1 capitalize">
              {currentProperty.homeType}
            </div>
          </div>
          <div className="pl-3 w-full">
            <div className="h-20">
              <div className="text-xl capitalize">
                {currentProperty.street.length >= 40
                  ? currentProperty.street.slice(0, 38) + "..."
                  : currentProperty.street}
              </div>
              <div className="flex items-center text-gray-400">
                {currentProperty.city + ", " + currentProperty.state}
                <div
                  className="pl-1 text-sm text-blue-500 hover:text-blue-700 cursor-pointer"
                  onClick={() => {
                    handleModal("editProperty");
                    setAddress(currentProperty);
                  }}
                >
                  Edit
                </div>
              </div>
            </div>
            <div className="flex items-center absolute right-3 bottom-0 pr-3">
              <div
                className="text-blue-500 hover:text-blue-700 pr-5 cursor-pointer"
                onClick={() => {
                  handleModal("addRoom");
                }}
              >
                + Add Room
              </div>
              <div
                className={` ${
                  currentPropertyLeases.length > 0
                    ? "text-gray-500"
                    : "text-red-500 hover:text-red-700 cursor-pointer"
                } `}
                onClick={() => {
                  if (currentPropertyLeases.length === 0)
                    handleAlert("deleteProperty");
                }}
              >
                Delete
              </div>
            </div>
          </div>
        </div>
        {currentPropertyRooms.length !== 0 ? (
          <div className="flex justify-center w-full px-5">
            <RoomsCard
              rooms={currentPropertyRooms}
              setCurrentRoomId={setCurrentRoomId}
              currentPropertyId={currentProperty.id}
            />
          </div>
        ) : (
          <div className="grid justify-items-center mt-20">
            <div
              className={`relative text-blue-500 hover:text-blue-700 border-blue-500
               hover:border-blue-700 border-2 rounded-full ${
                 rooms.length ? "" : "animate-bounce"
               }`}
              onClick={() => handleModal("addRoom")}
            >
              <IoBedOutline className="text-7xl" />
              <FaCirclePlus className="absolute -right-1 -bottom-1 text-3xl bg-white rounded-full" />
            </div>
            {/* <BsPersonAdd /> */}
            <div className="text-slate-500 text-center mt-5">
              This property has no rooms.
            </div>
            <div className="text-slate-500 text-center">Add a room above.</div>
          </div>
        )}
        {/* <div className="flex justify-center mt-10 mb-20">
          <Button
            background="bg-slate-400"
            text="text-white"
            opacity="bg-opacity-100"
            title={"Close"}
            height="h-10"
            width="w-24"
            borderColor="border-none"
            borderHover="hover:border-snappily-orange"
            customFunc={() => {
              handleModal("manageProperty");
            }}
          />
        </div> */}
      </div>
    </div>
  );
};

export default ManageProperty;
